import RootStore from '@stores/root.store';

const store = new RootStore();

export default store;
